<template>

<div>
  <a-modal v-model="modalOpen" title="Reservering verhuizen van organisatie/afdeling" @ok="handleOk">
    <div>
      <label class="typo__label font-weight-bold">Organisatie</label>
      <multiselect 
      :options="organizations" 
      :loading="loadingOrganizations"
      label="name" 
      placeholder="Selecteer een Organisatie"
      v-model="selectedOrganization" 
      track-by="id">
      </multiselect>
      
      
      <label
      class="typo__label font-weight-bold" 
      v-if="departments.length > 0">Afdelingen</label>
      <multiselect 
      :options="departments" 
      :loading="loadingDepartments"
      v-if="departments.length > 0"
      label="name" 
      placeholder="Selecteer een Afdeling"
      v-model="selectedDepartment" 
      track-by="id">
      </multiselect>
      <p class="text-danger" v-if="noDepartmentSelectedMessage">Er moet een afdeling geselecteerd worden.</p>
    </div>
    <a-button  type="primary" class="mt-3" @click="particulier()">Particulier </a-button>
  </a-modal>
  
</div>

</template>
<script>

export default {
  props: ['reservation_id', 'organization_id', 'department_id', 'reloadReservation'],
  computed: {
    user: {
        get: function () {
          return this.$store.state.user
        },
      },
  },
  watch: {
    selectedOrganization(newVal){
        this.departments = [];
        
        this.selectedDepartment = undefined;
        
        if(newVal !== null){
          this.fetchDepartments();
        }
      },
      selectedDepartment(newVal){ 
      }
  },
  data(){
    return {
      modalOpen: false,
      loadingOrganizations: false,
      loadingDepartments: false,
      noDepartmentSelectedMessage: false,
      organizations: [],
      departments: [],
      selectedOrganization: undefined,
      selectedDepartment: undefined,
    }
  },
  methods: {
        handleOk(){
          this.updateOrgDep();
        },
        openModal(){
          this.organizations = [];
          this.departments = [];
          this.fetchOrganizations();
          this.modalOpen = true;
        },
        fetchDepartments(){
          this.loadingDepartments = true;
          this.$axios.get('reservations/getDepartmentsByOrganizationId', {
            params: {
              organization_id: this.selectedOrganization.id
            },
            headers: {
              'Authorization': `Bearer ${this.user.user.token}`,
            }}).then(response => {
              this.departments = response.data;
              this.selectedDepartment = response.data.find(department=>department.id===this.department_id);
              this.loadingDepartments = false;
            });
        },
        fetchOrganizations(){
          this.loadingOrganizations = true;
          this.$axios.get('reservations/getOrganizations', {headers: {
            'Authorization': `Bearer ${this.user.user.token}`,
          }}).then(response => {
              this.organizations = response.data;
              this.selectedOrganization = response.data.find(organization=>organization.id===this.organization_id);
              this.loadingOrganizations = false;
          });
        },
        particulier(){
            this.selectedOrganization = undefined;
            this.selectedDepartment = undefined;
        },
        updateOrgDep(){
          this.noDepartmentSelectedMessage = false;
          if(this.departments.length > 0 && this.selectedDepartment === undefined && this.selectedOrganization !== undefined){
            this.$message.warning('Er moet een afdeling geselecteerd worden.');
            this.noDepartmentSelectedMessage = true;
            return;
          }
          this.$axios.post('reservation/moveOrgAndDep', {
            reservation_id: this.reservation_id,
            organization_id: this.selectedOrganization ? this.selectedOrganization.id : null,
            department_id: this.selectedDepartment ? this.selectedDepartment.id : null
          },
          {
            headers: {
              'Authorization': `Bearer ${this.user.user.token}`,
            }
          }).then(response=>{
            this.modalOpen = false;
            this.$message.success('Reservering verhuisd');
            this.reloadReservation();
          })
        }
  }
}

</script>